<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      用户行为回放
      <span class="sub-title">基于 rrweb 录制的页面操作记录，用于问题排查与操作审计</span>
    </div>
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="用户ID" prop="userId">
          <el-input
            v-model.trim="searchForm.userId"
            placeholder="请输入用户ID"
            clearable
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="用户名称" prop="userName">
          <el-input
            v-model.trim="searchForm.userName"
            placeholder="请输入用户名称"
            clearable
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="录制时间" prop="timeRange">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="handleSearch">
            搜索
          </el-button>
          <el-button @click="resetSearch">
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="userId" label="用户ID" align="left" min-width="110" />
          <el-table-column prop="userName" label="用户名称" align="left" min-width="110" />
          <el-table-column label="页面" align="left" min-width="240">
            <template v-slot="{ row }">
              <div class="page-title">{{ row.title || '-' }}</div>
              <el-tooltip
                v-if="row.url"
                :content="row.url"
                placement="top"
                popper-class="behavior-replay-tooltip"
              >
                <div class="page-url">{{ row.url }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="eventCount" label="事件数" align="right" width="100" />
          <el-table-column prop="batchCount" label="批次数" align="right" width="100" />
          <el-table-column prop="ip" label="客户端IP" align="left" width="140" />
          <el-table-column label="开始时间" align="left" min-width="170">
            <template v-slot="{ row }">
              {{ formatTime(row.startTime) }}
            </template>
          </el-table-column>
          <el-table-column label="结束时间" align="left" min-width="170">
            <template v-slot="{ row }">
              {{ formatTime(row.endTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template v-slot="{ row }">
              <el-button type="text" @click="openReplay(row)">
                回放
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 50]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.pageIndex"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            hide-on-single-page
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBehaviorSessions } from '@/API/behaviorLog';

export default {
  name: 'BehaviorReplayList',
  data () {
    return {
      tableLoading: false,
      searchForm: {
        userId: '',
        userName: '',
        timeRange: []
      },
      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  created () {
    this.queryList();
  },
  methods: {
    buildParams () {
      const range = this.searchForm.timeRange || [];
      return {
        userId: this.searchForm.userId,
        userName: this.searchForm.userName,
        startTime: range[0] || '',
        endTime: range[1] || '',
        pageNum: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
    },
    async queryList () {
      this.tableLoading = true;
      try {
        const data = await getBehaviorSessions(this.buildParams());
        this.tableData = (data && data.list) || [];
        this.page.total = (data && data.total) || 0;
      } catch (e) {
        this.tableData = [];
        this.page.total = 0;
        this.$message.error(e.message || '查询行为日志失败');
      } finally {
        this.tableLoading = false;
      }
    },
    handleSearch () {
      this.page.pageIndex = 1;
      this.queryList();
    },
    resetSearch () {
      this.searchForm = {
        userId: '',
        userName: '',
        timeRange: []
      };
      this.page.pageIndex = 1;
      this.queryList();
    },
    handleSizeChange (size) {
      this.page.pageSize = size;
      this.page.pageIndex = 1;
      this.queryList();
    },
    handleCurrentChange (index) {
      this.page.pageIndex = index;
      this.queryList();
    },
    formatTime (value) {
      if (!value) {
        return '-';
      }
      // 后端直接返回数据库时间字符串，可能带毫秒后缀
      return String(value).replace(/\.\d+$/, '');
    },
    openReplay (row) {
      this.$router.push({
        name: 'behaviorReplayDetail',
        params: { sessionId: row.sessionId }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-title {
  margin-left: 12px;
  font-size: 12px;
  font-weight: normal;
  color: #909399;
}

.page-title {
  color: #303133;
  line-height: 20px;
}

.page-url {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>
